type PrimitiveValue = string | number | boolean | null | undefined;

function hasValue(value: PrimitiveValue): boolean {
  if (value === undefined || value === null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  return true;
}

export function hasActiveListCriteria<T extends Record<string, any>>(
  params: T,
  keys: Array<keyof T | string>,
): boolean {
  return keys.some((key) => hasValue(params[key as keyof T] as PrimitiveValue));
}

/**
 * `all=true` is only valid for the default unfiltered list view.
 * If any search or filter field is active, remove `all`.
 */
export function normalizeAllForList<T extends Record<string, any>>(
  params: T,
  criteriaKeys: Array<keyof T | string>,
): T {
  if (!hasActiveListCriteria(params, criteriaKeys)) return params;

  const next = { ...params };
  delete next.all;
  return next;
}

export function buildDefaultListParams<T extends Record<string, any>>(
  params: T,
  criteriaKeys: Array<keyof T | string>,
): T {
  const next = normalizeAllForList(params, criteriaKeys);
  if (hasActiveListCriteria(next, criteriaKeys) || next.all !== undefined) {
    return next;
  }

  return {
    ...next,
    all: true,
  };
}
